import { render, staticRenderFns } from "./AutoReplyItem.vue?vue&type=template&id=2f0424c4&scoped=true"
import script from "./AutoReplyItem.vue?vue&type=script&lang=js"
export * from "./AutoReplyItem.vue?vue&type=script&lang=js"
import style0 from "./AutoReplyItem.vue?vue&type=style&index=0&id=2f0424c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0424c4",
  null
  
)

export default component.exports